import * as React from 'react';
import { Select } from '@cian/ui-kit/select';
import { IPreparedPackage } from './types';

interface IPackagesProps {
  value: string | null;
  packages: IPreparedPackage[];
  onChange(value: string): void;
}

export const Packages = ({ value, packages, onChange }: IPackagesProps) => {
  return <Select value={value} size="M" options={packages} placeholder="Доступные пакеты" onChange={onChange} />;
};
